export default function TermsAndConditionsDriver() {
    return (
        <div>
            <h1>Entente entre Service de livraison OnShip.ca et le Contractant</h1>
            
            <p>Le présent contrat est conclu entre Service de livraison OnShip.ca (« la Société ») et le soussigné (« le Contractant » ou « le Travailleur autonome »).</p>

            <h2>1. Statut</h2>
            <ul>
                <li>Le Contractant agit en tant que travailleur autonome indépendant et non exclusif.</li>
                <li>Rien dans le présent contrat ne crée un lien d'emploi entre les parties.</li>
                <li>Le Contractant demeure libre de travailler pour d'autres entreprises en tout temps.</li>
            </ul>

            <h2>2. Services de livraison</h2>
            <ul>
                <li>Le Contractant fournit des services de livraison pour les clients et commerçants partenaires de la Société.</li>
                <li>La Société peut proposer des plages de travail en fonction des disponibilités indiquées par le Contractant, mais celui-ci demeure libre d'accepter ou de refuser les services proposés.</li>
            </ul>

            <h2>3. Matériel et équipements</h2>
            <ul>
                <li>Le Contractant doit fournir le matériel nécessaire à ses livraisons (véhicule, téléphone, GPS, sac de transport).</li>
                <li>Si le Contractant n'a pas les outils requis, la Société peut en prêter, louer ou vendre.</li>
                <li>Un dépôt de garantie peut être exigé en cas de prêt ou de location. Ce dépôt est remboursable dans les 14 jours suivant le retour du matériel en bon état.</li>
                <li>En cas de perte ou de bris du matériel prêté, des frais équivalents à la valeur de remplacement pourront être facturés.</li>
            </ul>

            <h2>4. Conditions d'utilisation du matériel</h2>
            <ul>
                <li>Le terminal de paiement demeure en tout temps la propriété de la Société.</li>
                <li>Le Contractant doit en prendre soin et le retourner à la fin de la collaboration.</li>
                <li>Des frais raisonnables peuvent s'appliquer en cas de perte, de bris ou de non-retour.</li>
            </ul>

            <h2>5. Responsabilités</h2>
            <ul>
                <li>Le Contractant assume la totalité des pertes encourues dans l'accomplissement de ses services.</li>
                <li>La Société n'est pas responsable en cas d'accident, blessure ou décès.</li>
                <li>Il est recommandé au Contractant de souscrire une assurance responsabilité civile.</li>
            </ul>

            <h2>6. Règles de conduite</h2>
            <p>Le Contractant doit agir de manière professionnelle auprès des clients et commerçants.</p>
            <p>Quelques règles doivent être respectées :</p>
            <ul>
                <li>ne pas transporter de passagers ni d'animaux durant les livraisons;</li>
                <li>ne pas bloquer les entrées principales des commerces;</li>
                <li>utiliser un sac de transport adapté et en bon état;</li>
                <li>avoir une tenue soignée.</li>
            </ul>
            <p>L'identification On Ship Ça peut être portée, mais elle n'est pas obligatoire.</p>

            <h2>7. Non-sollicitation</h2>
            <ul>
                <li>Pendant le contrat et pour une durée maximale de 3 mois suivant sa fin, le Contractant s'engage à ne pas solliciter directement les commerçants desservis par la Société pour offrir des services de livraison concurrents.</li>
            </ul>

            <h2>8. Rémunération et paiements</h2>
            <ul>
                <li>Le Contractant est rémunéré pour chaque livraison complétée.</li>
                <li>Les paiements sont versés directement par dépôt bancaire.</li>
                <li>En cas de dette avérée envers la Société (ex. matériel non retourné), des prélèvements peuvent être effectués, après avis écrit.</li>
            </ul>

            <h2>9. Résiliation</h2>
            <ul>
                <li>Le contrat peut être résilié par l'une ou l'autre des parties avec un préavis écrit de 7 jours.</li>
                <li>En cas de manquement grave, la résiliation peut être immédiate.</li>
            </ul>
        </div>
    )
}
